import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {LiveCasinoArenaNavbarButtonDefaultBox} from "./live-casino-arena-navbar-button.default.box";
import {LiveCasinoArenaNavbarButtonCasino777Box} from "./live-casino-arena-navbar-button.casino777.box";
import {LiveCasinoArenaNavbarButtonSIBox} from "./live-casino-arena-navbar-button.si.box";
import {LiveCasinoArenaNavbarButtonMrGreenBox} from "./live-casino-arena-navbar-button.mrgreen.box";

export const LiveCasinoArenaNavbarButtonBox = styledByTheme(LiveCasinoArenaNavbarButtonDefaultBox)
    .forCasino777(LiveCasinoArenaNavbarButtonCasino777Box)
    .forSI(LiveCasinoArenaNavbarButtonSIBox)
    .forSICis(LiveCasinoArenaNavbarButtonSIBox)
    .forMrGreen(LiveCasinoArenaNavbarButtonMrGreenBox)
    .forMrGreenCis(LiveCasinoArenaNavbarButtonMrGreenBox)
    .apply();
